import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent , MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, of } from 'rxjs';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { PropertyName } from 'src/app/core/enumerations/sectionNames';
import { Constants } from '../../constants';
import { OrderDynamicErrors } from '../../error-messages';
import { BroadcastService } from '../../services/broadcast.service';
import { DynamicFormServiceService } from '../../services/dynamic-form-service.service';
import { Option } from 'src/app/core/interfaces/options-dynamicform';


@Component({
    selector: 'app-sample-source',
    templateUrl: './sample-source.component.html',
    standalone: false
})
export class SampleSourceComponent implements OnInit {

  field: OrderFieldConfig;
  group: UntypedFormGroup;
  noData: boolean;
  massDropdown = new Observable<Option[]>();
  sortedOptions: Option[];
  noRecord = 'noRecord';
  isRequired: boolean;
  required = Constants.IS_REQUIRED;
  invalid = 'invalid';
  selectValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectValueChangeObservable = this.selectValueChange.asObservable();
  initValue = true;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  constructor(private broadCastService: BroadcastService,
              private dynamicService: DynamicFormServiceService,
              private cdRef: ChangeDetectorRef,
              public broadcastService: BroadcastService) { }

  ngOnInit() {
    this.massDropdown = of(this.sortedOptions = this.field.options);
    this.group.get(this.field.labelCode).setValidators(this.invalidOptionValidator.bind(this));
    this.group.get(this.field.labelCode).valueChanges.subscribe(x => this.noData = false);
    if (this.group.get(this.field.labelCode).value) {
        const index = this.sortedOptions.findIndex(x => x.value + ' ' + '(' + x.code + ')'
        === this.group.get(this.field.labelCode).value);
        let defaultValue: any;
        if (index > -1) {
          defaultValue = this.sortedOptions[index];
          this.group.get(this.field.labelCode).setValue(defaultValue.value + ' ' + '(' + defaultValue.code + ')');
        }
    }
    if(this.field.type === 'selectSearchBox' && this.field.options.length==0){
      this.field.disabled=true;
    }
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    this.broadCastService.subscribe().subscribe(message => {
      if (message.type === Constants.IsSpecimenAdded) {
        if (this.field.isScannable && message.payload.event) {
          this.group.get(this.field.labelCode).setValue('');
          this.massDropdown = of(this.sortedOptions = this.field.options);
        }
      } else if (message.type === Constants.SPECIMEN_EDITED) {
        this.massDropdown = of(this.sortedOptions = this.field.options);
        this.group.get(this.field.labelCode).setValue(message.payload.SampleSource);
      } else if(message.type === Constants.SAMPLE_SOURCE_REFRESH){
        this.field.options = message.payload;
        this.group.get(this.field.labelCode).reset();
        this.sortedOptions = this.field.options;
        this.massDropdown = of(this.sortedOptions);
        this.cdRef.detectChanges(); 
      }
    });
    this.broadcastService.broadcast(Constants.SAMPLE_SOURCE_READY, true);
  }

  getValueAndCode(item, fieldCode) {
    if (fieldCode === PropertyName.SampleSource) {
      return item.value + ' ' + '(' + item.code + ')';
    }
    return item.value;
  }

  selectionOptionChanged(event: MatAutocompleteSelectedEvent) {
    if (event.option && event.option.id !== this.noRecord) {
      this.group.get(this.field.labelCode).setValue(event.option.viewValue);
      if (this.field.labelCode === PropertyName.SINGLE_TEST) { sessionStorage.setItem('sampleSource', event.option.id); }
    }
  }

  OnEnter(event: any) {
    let inputValue: any;

    if (typeof event === 'string') {
      inputValue = event;
    } else { inputValue = event.target.value; }
    const dropdownValues: Option[] = this.sortedOptions;
    let valFound: boolean;
    const self = this;
    if (this.field.isScannable) {
      const result = dropdownValues.filter((itm) => {
        const sampleFullname = itm.value + ' (' + itm.code + ')';
        return ((inputValue.toLowerCase() === itm.code.toLowerCase()) || (inputValue.toLowerCase() === sampleFullname.toLowerCase()));
      });

      if (result.length > 0) {
        self.group.get(self.field.labelCode).setValue(result[0].value + ' (' + result[0].code + ')');
        self.group.get(self.field.labelCode).setErrors(null);
        self.field.validations = self.field.validations.filter(x => x.name !== 'invalid');
        valFound = true;
        this.broadCastService.broadcast(Constants.AddSpecimen, true);
      } else {
        const res = self.field.validations.filter(x => x.name === 'invalid')
        if (inputValue && res.length === 0) {
          self.group.get(self.field.labelCode).setErrors({ invalid: true });
          self.field.validations.push({
            name: this.invalid, validator: this.invalid,
            message: OrderDynamicErrors.ImproperSepcimenCodeError
          });
          self.field.validations = self.field.validations.filter(x => x.name !== 'required');
          self.cdRef.detectChanges();
        }
        self.group.get(self.field.labelCode).setErrors({ invalid: true });
      }
      this.selectValueChange.emit(valFound);
    }
  }

  valuechanges(event: any) {
    if (this.field.isScannable && event?.includes(`(${event})`)) {
      this.OnEnter(event);
    }
  }

  clearOnBackSpace(formControlName) {
    this.massDropdown = of(this.sortedOptions);
    this.group.get(formControlName).reset();
    this.autocomplete.openPanel();
  }

  invalidOptionValidator(c: UntypedFormControl) {
    if (c.value && this.sortedOptions.length) {
      const word = c.value.toLowerCase().trim();
      let acc: Option[] = [];
      const val = this.sortedOptions.filter(o =>
        Object.keys(o).some(k => (o.value + ' (' + o.code + ')').toLowerCase().includes(word)));
      acc = acc.concat(val).filter((v, i, a) => a.indexOf(v) === i);
      this.noData = acc.length <= 0;
      this.massDropdown = of(acc);
      const index = acc.findIndex(x => word === this.valueToBecompared(x));
      if (this.noData || index === -1) {
        return { invalidAutocompleteObject: true };
      }
      return null;  /* valid option selected */
    }
    return null;
  }

  valueToBecompared(x) {
    const val = this.field.labelCode === PropertyName.SampleSource ?
    x.value.toLowerCase() + ' (' + x.code.toLowerCase() + ')' :  x.value.toLowerCase();
    return val;
  }
}

